import { render } from "./FarmOsField.vue?vue&type=template&id=86638d1e&scoped=true"
import script from "./FarmOsField.vue?vue&type=script&lang=js"
export * from "./FarmOsField.vue?vue&type=script&lang=js"

import "./FarmOsField.vue?vue&type=style&index=0&id=86638d1e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86638d1e"]])

export default __exports__